import { URLS } from '../../../consts/endpoints';
import { getData } from '../../../utils/http';
import {
  isArray,
  isDefined,
  isObject,
  isUndefined
} from '../../../utils/isDefined';
import Optional from '../../../utils/optional';

const getSubscriptionDetails = async ({
  setIsLoading = () => {},
  clientId,
  externalReference
}) => {
  setIsLoading(true);
  let subProblems = void 0;
  let subMigration = void 0;
  let userInfo = void 0;

  try {
    const details = await getData(
      `${URLS.QUOTE_CLIENTS_V2}/${clientId}/subscriptions/${externalReference}`
    );

    if (isDefined(details?.migration)) {
      subMigration = details?.migration;
    }

    if (
      isDefined(details?.problems) &&
      isArray(details?.problems) &&
      details.problems.length > 0
    ) {
      subProblems = details?.problems;
    }

    if (isArray(details?.features)) {
      const userFeature = details?.features.find(
        feature => feature?.key === 'user-info'
      );

      if (isDefined(userFeature)) {
        userInfo = userFeature;
      }

      const phoneNumber = findPhoneNumber(details?.features);

      if (isDefined(phoneNumber)) {
        userInfo = { ...userInfo, phoneNumber };
      }
    }
  } catch {
  } finally {
    setIsLoading(false);
    return { subProblems, subMigration, userInfo };
  }
};

export default getSubscriptionDetails;

const findPhoneNumber = features => {
  if (!isArray(features)) return void 0;
  const phoneAndSimcardFeature = features.find(
    feature => isObject(feature) && feature?.key === 'phone-and-sim-card'
  );

  if (isUndefined(phoneAndSimcardFeature?.featureAttributes)) return void 0;

  const phoneNumberFeatures = phoneAndSimcardFeature.featureAttributes.find(
    feature =>
      isObject(feature) && feature?.key === 'resources-phone-numbers-primary'
  );

  return Optional(phoneNumberFeatures?.value).or(void 0);
};
